import * as React from "react";
import { App } from "./app"
import { ArticleGW } from "./ArticleGW"
import { BDKalkCore } from "./BDKalkCore"
import { Assert } from "./PADebug"
import { Debug } from "./PADebug"
import { ExtInfoViewGW } from "./ExtInfoViewGW"

interface ChoiseControlVm {
    core: BDKalkCore
    extInfoView: ExtInfoViewGW
    index: number
    unitMeasure:number
}

interface ChoiseControlStates {
    hovering: boolean,
    minusPressed: boolean,
    plusPressed: boolean
}

/*  ChoiseControlExtInfoUnit is an amount controlling device which applies to an alternative measurement unit
    for an article, accessed within the extended info view for any given article. */
export class ChoiseControlExtInfoUnit extends React.Component<ChoiseControlVm, ChoiseControlStates> {

    constructor(props: ChoiseControlVm) {
        super(props)
    }
    
    // Sets the reference to this control within the article item on initiation
    componentWillMount() {
        this.props.extInfoView.ConnectUnitChoise(this)
    }
    
    state = {
        hovering: false,
        minusPressed: false,
        plusPressed: false
    }

    SetActivePakke() {
        var article = this.props.extInfoView.props.app.GetSelectedArticle()

        if (article == null) {
            Assert(false, "ChoiseControlExtInfoUnit.render - there was no article assigned for the ext info!")
            return <div>(Error : Missing article!)</div>
        }
        
        var extData = article.GetIfHasExtData()

        if (extData == null) {
            extData = this.props.core.GetExtData()
        }

        if (extData != null) {
            extData.SetActivePakkeIndex(this.props.index)
        }

        this.ClearLastInput()

        // this.props.extInfoView.forceUpdate()
    }
    
    // Handler for the clicks on the minus button, which are passed on to a handler within BDKalkCore
    MinusClick() {
        this.props.extInfoView.SetLocation("minus", this)
        this.SelectThisUnit()
    }

    // Handler for the minus button being pressed (which will change its graphics)
    MinusDown() {
        this.setState({ minusPressed: true })
        this.SetActivePakke()
    }

    // Handler for the minus button being released (which will change its graphics)
    MinusUp() {
        this.setState({ minusPressed: false })
    }

    // Handler for the plus button being pressed (which will change its graphics)
    PlusDown() {
        this.setState({ plusPressed: true })
        this.SetActivePakke()
    }

    // Handler for the plus button being released (which will change its graphics)
    PlusUp() {
        this.setState({ plusPressed: false })
    }

    // Handler for the clicks on the plus button, which are passed on to a handler within BDKalkCore
    PlusClick() {
        this.props.extInfoView.SetLocation("plus", this)
        this.SelectThisUnit()
    }
    
    // Handler for when the central area gets clicked (will change the control into typing mode)
    CenterClick() {
        this.props.extInfoView.SetLocation("input", this)
        this.SetActivePakke()
    }
    
    // Handler for when the mouse leaves the numeric control (may affect the graphics of the control)
    MouseOut() {
        if (this.props.extInfoView.GetInputActive(this) == false) {
            this.setState({ minusPressed: false, plusPressed: false })
        }
        else {
            this.m_textInput.click()
        }

        if (this.props.extInfoView.GetInputActive(this) == true) {
            alert("mouseOut where input was active")
        }    
    }

    // A warning when the entered input is not a valid number
    handleBadInput() {
        if (this.m_textInput.value.length > 0) {
            alert("Du m� skrive inn mengde som et tall, du kan kun bruke sifrer og maks et komma tegn.")
        }
    }
    
    // Checks if the input is a valid number and enters it if so, or calls handleBadInput()
    processInput() {
        var checkedValue = ""
        var dat = this.props.core.GetLastExtInfoInputValue()
        if (dat) {
            checkedValue = dat
        }

        if (this.m_textInput == null) {
            return
        }

        var tested = this.props.core.GetApp().ParseToPositiveNumber(checkedValue)

        if (tested == null) {
            this.handleBadInput()
            return
        }
        
        /* The number has been concidered valid and will be entered as 
           a new amount for the article. This also means that the total sum
           display has to be up to date afterwards. The following actions
           however may cause the thread to be killed due to some update which
           replaces the owner of an ongoing process, so instead of updating
           the total sum display directly at the end here, this action is
           delayed to ensure it an active thread when the delay has passed. */
        setTimeout(this.props.core.RedrawTotalSum.bind(this.props.core), 40)

        // ...the same works for the update of ext info view, which might need a refresh due to 
        // how the total weight displayed there get affected by an amount change.
        setTimeout(this.props.core.UpdateExtInfoView.bind(this.props.core), 50)
        
        var article = this.props.extInfoView.props.app.GetSelectedArticle()

        this.props.extInfoView.InsertControlValue(tested, this)
    }

    // Handler for keydown events
    onKeyDown(key: string) {
        var previousValue = ""
        var dat = this.props.core.GetLastExtInfoInputValue()
        if (dat) {
            previousValue = dat
        }
        
        if ((key == "0") || (key == "1") || (key == "2") || (key == "3") || (key == "4") || (key == "5") || (key == "6") || (key == "7") || (key == "8") || (key == "9")) {
            if (this.HasBegunTyping() == false) {
                this.SetNewValue(key)
            }
            else {
                if (previousValue == "0") {
                    this.SetNewValue(key)
                }
                else {
                    this.SetNewValue(previousValue + key)
                }
            }

            this.processInput()
            this.forceUpdate()
            return
        }

        if ((key == ".") || (key == ",")) {
            if (this.HasBegunTyping() == false) {
                this.SetNewValue(key)
            }
            else {
                for (var p = 0; p < previousValue.length; p++) {
                    if (previousValue.charAt(p) == ",") {
                        return
                    }
                }
                this.SetNewValue(previousValue + ",")
            }

            this.processInput()
            this.forceUpdate()
            return
        }
        
        if (key == "Backspace") {
            if (this.HasBegunTyping() == false) {
                this.SetNewValue("")
            }
            else {
                var newStr = this.GetNewValue()
                if (newStr) {
                    if (newStr.length > 0) {
                        const prevStr = newStr
                        newStr = ""

                        for (var s = 0; s < (prevStr.length - 1); s++) {
                            newStr += prevStr.charAt(s)
                        }
                    }

                    if (newStr.length > 0) {
                        this.SetNewValue(newStr)
                    }
                    else {
                        this.SetNewValue("0")
                    }
                }
                else {
                    this.SetNewValue("0")
                }
            }

            this.processInput()
            this.forceUpdate()
            return
        }

        if ((key == "ArrowLeft") || (key == "ArrowRight") || (key == "Delete")) {
            return
        }

        if ((key == "ArrowUp") || (key == "ArrowDown")) {
            return
        }

        if ((key == "Enter") || (key == "Tab")) {
            this.processInput()
            return
        }

        if (key == "Control") {
            return
        }
        
        // alert("Venligst benytt kun numeriske tegn! (Du tastet: \"" + key + "\")")
       
        return
    }

    ReachForFocus() {
        if (this.m_textInput) {
            this.m_textInput.autofocus = true
            this.forceUpdate()
        }
    }
    
    // Rendering the numeric control device of an article item
    render() {
        var article = this.props.extInfoView.props.app.GetSelectedArticle()

        if (article == null) {
            Assert(false, "ChoiseControlExtInfoUnit.render - there was no article assigned for the ext info!")
            return <div>(Error : Missing article!)</div>
        }

        var calculatedValue = this.props.extInfoView.GetAlternateValue(this)
        var amount = "0"

        if (calculatedValue != undefined) {
            amount = this.props.core.GetApp().GetRoundedNumericString(calculatedValue)
        }

        var def = ""
        var dat = this.props.core.GetLastExtInfoInputValue()
        if (dat) {
            def = dat
        }
        
        if (this.props.extInfoView.GetInputActive(this)) {

            var inputItem = <div style={{ display: "flex", flexDirection: "row", position: "relative", left: "4px", top: "11px", height: "15px" }}>
                <div style={{ position: "relative", top: "-3px" }}>{def}</div>
                <input
                    type="text"
                    ref={(input) => { if (input != null) this.m_textInput = input }}
                    id="inputToBeFocusedOn"
                    onKeyDown={(par) => { this.onKeyDown(par.key) }}
                    value={""}
                    autoFocus={true}
                    style={{
                        position: 'relative',
                        width: '1px',
                        height: '20px',
                        top: '-6px',
                        left: '0px',
                        border: '0px'
                    }}>
                </input>
            </div>
            
            // setTimeout(this.ReachForFocus.bind(this), 6000)
            
            // this.props.core.GetApp().ReFocus() // Calls a delayed focus to the input area
            // Grey amount is the value shown in ligth gray when input is active but nothing has been entered yet
            var greyAmount = amount

            if (this.HasBegunTyping() == true) {
                greyAmount = ""
            }

            try {
                return <div style={{ height: "26px", display: "flex", flexDirection: "row" }}>
                    {/*   Minus button   */}
                    <div
                        style={{
                            cursor: "pointer",
                            backgroundImage: "url(images/ChoisePanelCollection.png)",
                            backgroundPosition: (this.state.minusPressed) ? "-16px -120px" : "-16px -90px",
                            width: "22px",
                            height: "29px"
                        }}
                        onClick={this.MinusClick.bind(this)}
                        onMouseDown={this.MinusDown.bind(this)}
                        onMouseUp={this.MinusUp.bind(this)}>
                    </div>

                    {/*   Numeric input   */}
                    <div style={{
                        position: 'relative',
                        width: '47px',
                        height: '29px',
                        backgroundImage: "url(images/ChoisePanelCollection.png)" }}>

                        {inputItem}

                        <div style={{
                            color: "#BBBBBB",
                            position: 'relative',
                            width: '45px',
                            height: '20px',
                            top: '-10px',
                            left: '4px',
                            border: '0px'
                        }}>{greyAmount}
                        </div>

                    </div>

                    {/*   Plus button   */}
                    <div
                        style={{
                            cursor: "pointer",
                            backgroundImage: "url(images/ChoisePanelCollection.png)",
                            backgroundPosition: (this.state.plusPressed) ? "0px -261px" : "0px -231px",
                            width: "22px",
                            height: "29px"
                        }}
                        onClick={this.PlusClick.bind(this)}
                        onMouseDown={this.PlusDown.bind(this)}
                        onMouseUp={this.PlusUp.bind(this)}>
                    </div>

                </div>;
            }

            catch (e) {
                Assert(false,"Error in choisecontrolExtInfoUnit.render() - exception: " + e.toString())
            }
        }
        else {
            return <div style={{ height: "29px", display: "flex", flexDirection: "row" }}>
                {/*   Minus button   */}
                <div
                    style={{
                        cursor: "pointer",
                        backgroundImage: "url(images/ChoisePanelCollection.png)",
                        backgroundPosition: (this.state.minusPressed) ? "-16px -120px" : "-16px -90px",
                        width: "22px",
                        height: "29px"
                    }}
                    onClick={this.MinusClick.bind(this)}
                    onMouseDown={this.MinusDown.bind(this)}
                    onMouseUp={this.MinusUp.bind(this)}>
                </div>

                {/*   Central text - amount   */}
                <div
                    style={{
                        backgroundImage: "url(images/ChoisePanelCollection.png)",
                        backgroundPosition: "0px 0px",
                        cursor: "pointer",
                        minWidth: "39px",
                        padding: "4px"
                    }}
                    onClick={this.CenterClick.bind(this)}>{amount}
                </div>

                {/*   Plus button   */}
                <div
                    style={{
                        cursor: "pointer",
                        backgroundImage: "url(images/ChoisePanelCollection.png)",
                        backgroundPosition: (this.state.plusPressed) ? "0px -261px" : "0px -231px",
                        width: "22px",
                        height: "29px"
                    }}
                    onClick={this.PlusClick.bind(this)}
                    onMouseDown={this.PlusDown.bind(this)}
                    onMouseUp={this.PlusUp.bind(this)}>
                </div>
            </div>;
        }
    }

    public HasBegunTyping() {
        const last = this.props.core.GetLastExtInfoInputValue()

        if (last != null) {
            if (last == "") {
                return false
            }
            
            if (this.props.core.GetLastExtInfoInputIndex() == this.props.index) {
                return true
            }
        }

        return false
    }

    SetNewValue(newValue: string) {

        const inp = this.m_textInput
        if (inp) {
            inp.value = newValue
        }
        
        if (newValue == "") {
            this.props.core.SetLastExtInfoInput(this.props.index, "0", null)
        }

        this.props.core.SetLastExtInfoInput(this.props.index, newValue, null)
    }
    
    GetNewValue() {
        const last = this.props.core.GetLastExtInfoInputValue()
        
        if (last != null) {
            if (this.props.core.GetLastExtInfoInputIndex() == this.props.index) {
                return last
            }
        }
        
        return null
    }
    
    SelectThisUnit() {
        this.props.core.SetLastExtInfoInput(this.props.index, null, null)
    }

    ClearLastInput() {
        this.props.core.ClearLastExtInfoInput()
    }
    
    m_textInput: HTMLInputElement // A handle to the input object
}



// WEBPACK FOOTER //
// ./client/view/ChoiseControlExtInfoUnit.tsx